import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';

import { AuthDataService } from '../services/auth-data.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private readonly authDataService: AuthDataService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return this.handleRequestWith401Retry(request, next);
  }

  private handleRequestWith401Retry(
    request: HttpRequest<unknown>,
    next: HttpHandler,
    retried = false
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err?.status === 401 && !retried) {
          this.authDataService._needsUpdate$.next();
          return this.authDataService._foundUser$.pipe(
            take(1),
            switchMap(() => this.handleRequestWith401Retry(request, next, true))
          );
        }
        return throwError(() => err);
      })
    );
  }
}
